export enum ScreenNamesEnum {
  ChatScreen = 'chat',
  MainScreen = 'main',
  SignIn = 'signin',
  DoctorsList = 'doctors-list',
  DoctorProfile = 'doctor-profile',
  HealthFacilities = 'health-facilities',
  QueueList = 'queue-list',
  PaymentDone = 'payment-done',
}
